// extracted by mini-css-extract-plugin
var _1 = "TopicTreeCardPostIcon-module__icon--WeUPI";
var _2 = "TopicTreeCardPostIcon-module__movedOut--MRk_V";
var _3 = "TopicTreeCardPostIcon-module__template--Y1CS6";
export { _1 as "icon", _2 as "movedOut", _3 as "template" }
